import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { dailyReports } from '../utils/mockData';

const { FiDownload, FiBarChart2 } = FiIcons;

const Reports = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold text-gray-100 tracking-wider uppercase">Intelligence Reports</h1>
          <p className="text-xs font-mono text-gray-500 uppercase mt-1">Daily Efficiency & Cost Audits</p>
        </div>
        <button className="flex items-center gap-2 bg-[#1a1a2e] hover:bg-[#00f0ff]/10 text-[#00f0ff] border border-[#00f0ff]/30 px-4 py-2 rounded text-[10px] font-mono uppercase tracking-widest transition-all">
          <SafeIcon icon={FiDownload} /> Export All (CSV)
        </button>
      </div>

      <div className="hud-panel overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#11111a] border-b border-[#1a1a2e]">
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Cycle Date</th>
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Efficiency</th>
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Est. Fuel Cost</th>
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Incidents</th>
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Uptime</th>
                <th className="p-4 text-[10px] font-mono text-gray-500 uppercase tracking-widest">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#1a1a2e]">
              {dailyReports.map((report, idx) => (
                <motion.tr 
                  key={report.date}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: idx * 0.1 }}
                  className="hover:bg-[#11111a] transition-colors"
                >
                  <td className="p-4 text-xs font-mono text-gray-300">{report.date}</td>
                  <td className="p-4">
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-[#00f0ff] font-bold">{report.efficiency}</span>
                      <div className="w-12 h-1 bg-[#1a1a2e] rounded-full overflow-hidden">
                        <div className="h-full bg-[#00f0ff]" style={{ width: report.efficiency }} />
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-xs font-mono text-gray-300">{report.fuelCost}</td>
                  <td className="p-4">
                    <span className={`text-[10px] px-2 py-0.5 rounded font-mono ${report.incidents > 0 ? 'bg-red-500/20 text-red-500 border border-red-500/50' : 'bg-green-500/20 text-green-500 border border-green-500/50'}`}>
                      {report.incidents} ISSUES
                    </span>
                  </td>
                  <td className="p-4 text-xs font-mono text-gray-300">{report.uptime}</td>
                  <td className="p-4">
                    <button className="text-gray-500 hover:text-[#00f0ff] transition-colors">
                      <SafeIcon icon={FiBarChart2} />
                    </button>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="hud-panel p-6 bg-gradient-to-r from-[#0a0a12] to-transparent">
          <h4 className="text-xs font-mono text-gray-500 uppercase tracking-widest mb-4">Cost Trend (7D)</h4>
          <div className="h-32 flex items-end gap-2 px-2">
            {[40, 65, 45, 90, 55, 70, 60].map((h, i) => (
              <div key={i} className="flex-1 bg-[#00f0ff]/20 hover:bg-[#00f0ff]/40 transition-all rounded-t relative group" style={{ height: `${h}%` }}>
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#1a1a2e] text-[8px] px-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                  ${h*10}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="hud-panel p-6">
          <h4 className="text-xs font-mono text-gray-500 uppercase tracking-widest mb-4">Optimization Recommendation</h4>
          <p className="text-xs text-gray-400 font-mono leading-relaxed uppercase">
            &gt; Unit V-1047 exhibits high idle variance.<br/>
            &gt; Recommend dynamic rerouting for District 9.<br/>
            &gt; Est. monthly savings: <span className="text-green-500">$340.00</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Reports;